import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Modals/Modal";
import { Table, TableColumn } from "@/components/Table/Table";

import { CompanyEnrichPreviewResponse } from "../schema/companyEnrich";

interface CompanyEnrichPreviewModalProps {
	isOpened: boolean;
	onClose: () => void;
	columns: TableColumn[];
	data?: CompanyEnrichPreviewResponse;
}

export const CompanyEnrichPreviewModal: FunctionComponent<CompanyEnrichPreviewModalProps> = ({
	isOpened,
	onClose,
	columns,
	data,
}) => {
	const { t } = useTranslation();

	return (
		<Modal handleClose={onClose} isOpened={isOpened} size="lg" title={t("basics.preview")}>
			<Table columns={columns} data={data?.items || []} hideFooter={true} hidePagination={true} />
			{data?.totalItems !== undefined && data.totalItems > 0 && (
				<div className="flex items-center justify-center mt-3 text-sm text-text-meta">
					{t("companyEnrich.previewCount", { count: data.totalItems })}
				</div>
			)}
			{data?.totalItems === 0 && (
				<div className="flex items-center justify-center mt-3 text-sm text-text-meta">
					{t("companyEnrich.noResults")}
				</div>
			)}
		</Modal>
	);
};
